import React, { ReactNode } from "react";
import "./ConfirmModal.less";
import { Modal } from "../../../../../BP2Components";
import IntlMessages from "../../../../../../util/IntlMessages";

interface IConfirmModalProps {
   title: ReactNode;
   description: ReactNode;
   onConfirm: () => void;
   confirmLabel: ReactNode;
   onCancel: (value: boolean) => void;
   isOpen: boolean;
   icon: any;
}

const ConfirmModal = ({
   icon,
   title,
   description,
   confirmLabel,
   onCancel,
   onConfirm,
   isOpen,
}: IConfirmModalProps) => {
   return (
      <Modal
         isOpen={isOpen}
         width={1080}
         height={window.innerHeight / 1.05}
         bodyStyles={{ overflowX: "auto" }}
         topBarStyles={{ border: "none" }}
         wrapClassName="no-resize"
      >
         <div className="confirm-modal">
            <div className="confirm-modal__icon">
               {icon ? <img src={icon} alt="modal-icon" /> : null}
            </div>
            <div className="confirm-modal__title">{title}</div>
            <div className="confirm-modal__description">{description}</div>
            <hr className="borderline" />
            <div className="confirm-modal__actions">
               <button
                  className="confirm-modal__button confirm-modal__button--cancel"
                  onClick={() => onCancel(false)}
               >
                  <IntlMessages id="global.cancel" />
               </button>
               <button
                  className="confirm-modal__button confirm-modal__button--confirm"
                  onClick={onConfirm}
               >
                  {confirmLabel}
               </button>
            </div>
         </div>
      </Modal>
   );
};

export default ConfirmModal;
